const tableInfo = [
    {
        purpose: 'Cumprir o contrato estabelecido com nossos clientes',
        legalBase: 'Será determinada pelo nosso cliente, na qualidade de controlador dos dados pessoais'
    },
    {
        purpose: 'Recrutamento e avaliação de aderência à vaga de trabalho',
        legalBase: 'Justificado com base em nossos legítimos interesses para assegurar que recrutamos os funcionários adequados'
    },
    {
        purpose: 'Facilitar a comunicação com você (inclusive em casos de emergência e para fornecer a você informações solicitadas)',
        legalBase: 'Justifica-se com base em nossos interesses  legítimos de assegurar comunicação e gestão de emergências adequadas na organização'
    },
    {
        purpose: 'Cumprir requisitos legais',
        legalBase: 'Necessário para a conformidade com uma obrigação legal à qual estamos sujeitos'
    },
    {
        purpose: 'Monitorar o uso que você faz dos nossos sistemas (incluindo monitorar o uso do nosso site e de quaisquer aplicativos e ferramentas que você utilizar)',
        legalBase: 'Justifica-se com base nos nossos interesses legítimos de evitar não conformidades e proteger nossa reputação'
    },
    {
        purpose: 'Escuta social (identificando e analisando o que está sendo dito sobre a Cashforce nas mídias sociais [somente conteúdo acessível publicamente] a fim de perceber sentimento, intenção, disposição e tendências de mercado, além das necessidades de nossos stakeholders para, dessa forma, melhorar nossos serviços)',
        legalBase: 'Justifica-se com base em nossos legítimos interesses em proteger nossos ativos e nossa marca nas mídias sociais'
    },
    {
        purpose: 'Melhorar a segurança e o funcionamento do nosso website, aplicativo, redes e informações',
        legalBase: 'Justifica-se com base em nossos legítimos interesses de assegurar que você terá uma experiência de usuário excelente e que nossas redes e informações são seguras'
    },
    {
        purpose: 'Realizar análises de dados, isto é, aplicar analytics em operações e dados do negócio para descrever, prever e melhorar o desempenho do negócio dentro da Cashforce e/ou proporcionar uma melhor experiência de usuário (mais detalhes sobre como usamos analytics em nosso site são encontrados em nossa Política de Cookies.',
        legalBase: 'Justifica-se com base em nossos interesses  legítimos de assegurar o funcionamento adequado das nossas operações de negócios'
    },
    {
        purpose: 'Oferecer nossos produtos e serviços para você (a menos que você tenha mostrado objeção em relação a tal tratamento)',
        legalBase: 'Justifica-se com base em nossos legítimos interesses de promover nosso negócio'
    },
    {
        purpose: 'Admnistrar benefícios aos funcionários',
        legalBase: 'Justifica-se com base no consentimento do funcionário, caso seja de seu interesse o recebimento de determinado benefício'
    },
    {
        purpose: 'Entrega de informações necessárias aos órgãos governamentais',
        legalBase: 'Para cumprimento de uma obrigação legal'
    },
]

export default tableInfo